import { useSelector } from "react-redux";
import AssetImage from "./AssetImage"

const AssetImageContainer = () => {

    const {
      barcodeReportAssetImages
    }: any = useSelector((state: any) => ({
      barcodeReportAssetImages: state.BarcodeReportReducer.barcodeReportAssetImages
    }));

  return (
    <AssetImage barcodeReportAssetImages={barcodeReportAssetImages} />
  )
}

export default AssetImageContainer